import React from "react";
import {
  FormField,
  FormInput,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddSystemUserDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddSystemUser: () => void;
  addingSystemUser: boolean;
  systemUserForm: {
    title: string;
    shortName: string;
    description: string;
    roleIds: string;
    privilegeTitle: string;
    functionsPerformed: string;
  };
  setSystemUserForm: React.Dispatch<
    React.SetStateAction<{
      title: string;
      shortName: string;
      description: string;
      roleIds: string;
      privilegeTitle: string;
      functionsPerformed: string;
    }>
  >;
}

export function AddSystemUserDialog({
  open,
  onClose,
  handleAddSystemUser,
  addingSystemUser,
  systemUserForm,
  setSystemUserForm,
}: AddSystemUserDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add System User"
      description="Define a user type and their authorized privileges"
      size="md"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddSystemUser}
          submitLabel={addingSystemUser ? "Saving" : "Save"}
          submitDisabled={!systemUserForm.title || addingSystemUser}
        />
      }
    >
      <FormField label="Title" required>
        <FormInput
          placeholder="e.g. Privileged Administrator"
          value={systemUserForm.title}
          onChange={(v) => setSystemUserForm((f) => ({ ...f, title: v }))}
        />
      </FormField>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Short Name">
          <FormInput
            placeholder="e.g. Admin"
            value={systemUserForm.shortName}
            onChange={(v) =>
              setSystemUserForm((f) => ({ ...f, shortName: v }))
            }
          />
        </FormField>
        <FormField label="Role IDs" hint="Comma-separated">
          <FormInput
            placeholder="e.g. system-admin, isso"
            value={systemUserForm.roleIds}
            onChange={(v) => setSystemUserForm((f) => ({ ...f, roleIds: v }))}
          />
        </FormField>
      </div>
      <FormField label="Description">
        <FormTextarea
          placeholder="Description of this user type and access level"
          value={systemUserForm.description}
          onChange={(v) =>
            setSystemUserForm((f) => ({ ...f, description: v }))
          }
          rows={2}
        />
      </FormField>
      <FormField label="Privilege Title">
        <FormInput
          placeholder="e.g. Full System Administration"
          value={systemUserForm.privilegeTitle}
          onChange={(v) =>
            setSystemUserForm((f) => ({ ...f, privilegeTitle: v }))
          }
        />
      </FormField>
      <FormField label="Functions Performed" hint="Comma-separated">
        <FormInput
          placeholder="e.g. System configuration, Code deployment"
          value={systemUserForm.functionsPerformed}
          onChange={(v) =>
            setSystemUserForm((f) => ({ ...f, functionsPerformed: v }))
          }
        />
      </FormField>
    </Modal>
  );
}
